import { Badge } from 'Components/Badge';
import DropPanelDesktop from 'Components/DropPanelDesktop';
import Icon from 'Components/Icon';
import LoginForm from 'Components/LoginForm';
import NoSSR from 'Components/NoSSR';
import PropTypes from 'prop-types';
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getUserTribunToken, loginUser, logoutUser, openModal, updateUserBalance, getDisplayCommunicationSettings, toggleSideMenu, getAllCategoriesList, clearPendingMembership, resetLoginFailure } from 'Store/actions';
import History from 'Store/history';
import { classnames } from 'Utils/classnames';
import { copyToClipboard } from 'Utils/copyToClipboard';
import { getActiveIndexByPath } from 'Utils/getActiveIndexByPath';
import { HEADER_LINKS } from 'Utils/getActiveIndexByPath';
import { BULLETIN_TYPES } from 'Store/constants/sportTypes';
import { TJK_URL_SUFFIX } from 'Store/constants/horseRacing';
import TvButton from 'Components/TvButton';
import { isMobile } from 'react-device-detect';

import RegisterLoginButtons from './RegisterLoginButtons';
import UserProfile from './UserProfile';
import { withMixpanel } from 'Utils/mixpanel';
import EnvironmentManager from 'Utils/environmentManager';
import Cookies from 'universal-cookie';
import withPrivacyEye from 'Components/PrivacyEyeHOC';
import SportTypeMenu from '../SportTypeMenu';
import VaixSearchInput from '../../pages/VaixSearch/Input';
import HeaderSkeleton from './HeaderSkeleton';
import TjkSubMenu from './TjkSubMenu';
import ThemeSegmentedControl from 'Components/Theme/ThemeSegmentedControl';
import { THEME_CLICK_POINTS } from 'Utils/theme';

class HeaderMobile extends Component {
  SCROLL_HEADER_SHOW_OFFSET = 30;

  static propTypes = {
    unreadAnnouncementsCount: PropTypes.number,
    type: PropTypes.string,
    location: PropTypes.object,
    auth: PropTypes.object,
    tribun: PropTypes.object,
    userAgent: PropTypes.object,
    loginUser: PropTypes.func,
    logoutUser: PropTypes.func,
    getUserTribunToken: PropTypes.func,
    helmet: PropTypes.object,
    openModal: PropTypes.func,
    getAllCategoriesList: PropTypes.func,
    helpMenuCategories: PropTypes.object,
    subHeader: PropTypes.object,
    showSubHeader: PropTypes.bool,
    getHelpMenuItems: PropTypes.func,
    updateUserBalance: PropTypes.func,
    mixpanel: PropTypes.object,
    getDisplayCommunicationSettings: PropTypes.func,
    allCategories: PropTypes.object,
    toggleSideMenu: PropTypes.func,
    privacy: PropTypes.object,
    showVaixSearch: PropTypes.bool,
    modalData: PropTypes.object,
    clearPendingMembership: PropTypes.func,
    resetLoginFailure: PropTypes.func,
    sportsBookTabs: PropTypes.shape({
      isLoading: PropTypes.bool,
      bulletinTabs: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number,
          count: PropTypes.number
        })
      )
    }),
  };


  constructor (props) {
    super(props);
    this.state = {
      popoverText: '',
      activeDropPanel: null,
      getBalanceDisable: false,
      countOpen: 0,
      isSearchEnabled: true,
      isDesktop: false,
      isAtTop: true
    };
  }

  handleScroll = () => {
    this.setState({ isAtTop: window.scrollY <= this.SCROLL_HEADER_SHOW_OFFSET });
  };

  componentDidMount () {
    this.updateIsDesktop();
    window.addEventListener('resize', this.updateIsDesktop);
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    if (!this.props.allCategories?.isLoading && !this.props.allCategories?.data?.all?.length) {
      this.props.getAllCategoriesList();
    }

    const resolveSearchToggle = async () => {
      await EnvironmentManager.waitForMessages();
      const toggleValue = EnvironmentManager.getMessageText({ key: 'main_page_search_toggle' });
      this.setState({
        isSearchEnabled: toggleValue === 'true'
      });
    };
    resolveSearchToggle();
  }


  isModalOpen = modalNameRequest => {
    const { modalNames } = this.props.modalData;
    return modalNames.some(modalName => modalName === modalNameRequest);
  };

  componentDidUpdate (prevProps) {
    const { subHeader } = this.props;
    if (subHeader && subHeader.data && subHeader?.data?.length > 0) {
      setTimeout(() => {
        this.manageMenuScroll();
      }, 100);
    }
    const wasTrustedOpenBefore = prevProps.modalData.modalNames.includes('trustedDeviceModal');
    const isTrustedOpenNow = this.isModalOpen('trustedDeviceModal');

    const wasErrorTrustedOpenBefore = prevProps.modalData.modalNames.includes('errorTrustedDeviceModal');
    const isErrorTrustedOpenNow = this.isModalOpen('errorTrustedDeviceModal');

    if ((isTrustedOpenNow && !wasTrustedOpenBefore)
      || (isErrorTrustedOpenNow && !wasErrorTrustedOpenBefore)) {
      this.closeDropPanel();
    }
  }

  manageMenuScroll = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const containerWidth = window.innerWidth;
      const contentWidth = document.querySelector('.header-desktop__sub-menu')?.scrollWidth;

      if (contentWidth > containerWidth) {
        document.querySelector('.header-desktop__sub-menu').classList.add('header-desktop__sub-menu--left');
      }
    }
  }

  openDropPanel = panelName => {
    this.setState({
      activeDropPanel: panelName
    });
    if (panelName === 'loginPanel') {
      this.props.clearPendingMembership();
      this.props.resetLoginFailure();
      this.props.mixpanel.track('View Login Pop up');
    }
  }

  closeDropPanel = () => {
    this.setState({
      activeDropPanel: null
    });
  }

  redirectHelpFromHeader = itemPath => {
    const isZendeskActive = EnvironmentManager.getMessageText({
      key: 'is_zendesk_live',
    }) === 'true';

    if (isZendeskActive && itemPath === '/yardim') {
      return window.open('https://yardim.bilyoner.com', '_blank');
    } else {
      History.push(itemPath);
    }
  }

  toggleMenu = (clickPoint = 'Hamburger Icon') => {
    this.setState({
      countOpen: this.state.countOpen + 1
    });
    this.props.mixpanel.track('Click Hamburger Menu', {
      'Click Point': clickPoint
    });
    this.props.toggleSideMenu();
  };

  setCookie = () => {
    const cookies = new Cookies();
    cookies.set('redirect', true, { path: '/' });
    window.location.reload();
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.updateIsDesktop);
    window.removeEventListener('scroll', this.handleScroll);
    clearTimeout(this.popoverTimeout);
    this.props.resetLoginFailure();
  }

  showPopover = () => {
    if (!this.state.popoverText) {
      this.setState(
        {
          popoverText: 'Üye Numarası kopyalandı'
        },
        () => {
          this.popoverTimeout = setTimeout(() => {
            this.setState({
              popoverText: ''
            });
          }, 2000);
        }
      );
    }
  };

   redirectRaffleUrl = ()=>{
     if (!this.props.auth?.data?.accessToken)
       History.push('/sans-oyunlari/esya-piyangosu');
     else {
       this.props.getDisplayCommunicationSettings().then(res => {
         if (this.props?.auth?.data?.accessToken && res?.data?.displayable && !(res?.data?.contactPermission.campaignEmail && res?.data?.contactPermission.campaignSms && res?.data?.contactPermission.campaignCallCenter))
           History.push('/sans-oyunlari/esya-piyangosu/iletisim-izinleri', { deeplinkParam: false });
         else {
           History.push('/sans-oyunlari/esya-piyangosu');
         }
       });
     }
   };

  renderMegaHeaderAccountInfo = () => {
    const isTribunPage = History?.location?.pathname?.startsWith('/tribun');
    const isMpPages = History?.location?.pathname?.startsWith('/milli-piyango');
    const isTjkPages = History?.location?.pathname?.startsWith('/tjk');
    const accountPathname = this.props.location?.pathname || History?.location?.pathname;
    const isHomePage = accountPathname === '/' || accountPathname == null;

    const { auth: { data: { name, surName, userId } }, unreadAnnouncementsCount } = this.props;
    const privacy = this.props.privacy;

    const showTvButton = History?.location?.pathname?.includes(TJK_URL_SUFFIX.program.fullPage) || History?.location?.pathname?.includes(TJK_URL_SUFFIX.fixedOdd.fullPage);

    const iconClasses = classnames({
      'account-balance__sync-icon': true,
      'account-balance__sync-icon__animate': this.state.getBalanceDisable,
    });

    const referencePageTitle =  EnvironmentManager.getMessageText({ key: 'reference_page_menu_title' }) || 'Bilyonpuan Festivali';
    const informationSecurityPolicyTitle = EnvironmentManager.getMessageText({ key: 'information_security_policy_title' });

    return (
      <>
      <div className="header-profile header-profile--ml-0">
        { /* <div className="header-profile__toggler" > */ }
        <div className={ classnames({
          'header-profile__info': true,
          'header-profile__info--inline': isHomePage,
          'header-profile__info-row': showTvButton,
        }) }>
          <div className="header-profile__info__main">
            <div className="header-profile__info__eye">
              <i onClick={ () => {
                this.props.mixpanel.track('Member Info Visibility', {
                  'Visibility Value': privacy?.isEyeOpen ? 'Pasif' : 'Aktif'
                });
                privacy?.toggleEye();
              } } className={ `${privacy?.icon} bly-size24 bly-white` }/>
            </div>
            { !isHomePage && (
              <div className="header-profile__info__name">
                { privacy?.name }
              </div>
            ) }
          </div>
          <div className="header-profile__info__balance" onClick={ () => {
            this.toggleMenu('User Name');
          } }>{ privacy?.isEyeOpen ? `${privacy?.balance} ₺` : privacy?.balance }</div>
        </div>
        { /* </div> */ }
        <div className="header-profile__hamburger header-profile--center" onClick={ () => this.toggleMenu() }>
          <i className="bly bly-avatar-new bly-white bly-size24"/>
          { unreadAnnouncementsCount > 0 && <Badge className="header-profile__hamburger__badge">
            { unreadAnnouncementsCount }
          </Badge> }
        </div>
      </div>

  <div className="account">

    { isMpPages ?  <div className="account-money"><Link className={ classnames({
      'btn-money': true,
      active: History.location?.pathname === '/milli-piyango/biletlerim'
    }) }
    to={ '/milli-piyango/biletlerim' } title={ 'Biletlerim' }>
      <Icon iconName="svgMp" />
        Biletlerim
    </Link> </div> :  <div className="account-coupons"><Link className={ classnames({
      'btn-coupons': true,
      'btn-coupons--active': History.location?.pathname?.includes('/kuponlarim')
    }) } to={ isTjkPages ? '/tjk/at-yarisi-kuponlarim' : '/kuponlarim' } title={ 'Kuponlarım' }>
      { isTjkPages ? <Icon iconName="svgAgNav" /> : <i className="bly bly-coupons bly-white bly-size16" /> }
      <span>{ isTjkPages ? 'AT YARIŞI KUPONLARIM' : 'KUPONLARIM' }</span>
    </Link> </div> }


    <div className="account-money">
      <Link className={ classnames({
        'btn-money': true,
        'tribun-page': isTribunPage,
      }) }
      onClick={ () => {
        this.props.mixpanel.track('View Deposit Page', {
          'Page Name': 'Ana Sayfa'
        });
      } }
      to={ '/hesabim/para-yatir' } title={ 'Para Yatır' }>
        <Icon iconName="svgDepositMoney" />
          Para Yatır
      </Link>
    </div>

    <div className="account-info" onClick={ () => {
      this.state.activeDropPanel === 'accountPanel' ? this.closeDropPanel : this.openDropPanel('accountPanel');
    } }>
      <ThemeSegmentedControl
        compact
        className="account-info__theme-toggle"
        clickPoint={ THEME_CLICK_POINTS.HEADER }
      />
      <div className="account-info__detail__eye">
        <i onClick={ event => {
          event.stopPropagation();
          this.props.mixpanel.track('Member Info Visibility', {
            'Visibility Value': privacy?.isEyeOpen ? 'Pasif' : 'Aktif'
          });
           privacy?.toggleEye();
        } } className={ privacy?.icon } />
      </div>
      <div className='account-info__detail__wrapper'>
        <div className="account-info__detail">
          <div className="account-info__detail__name">{ !privacy.isEyeOpen ? (` ${privacy.name}`) : ` ${name} ${surName}` }</div>
          <div
            className="account-info__detail__id"
            onClick={ event => {
              event.stopPropagation();
              this.props.mixpanel.track('Click Copy Member ID', {
                'Click Point': 'Homepage Header'
              });
              copyToClipboard(userId, this.showPopover);
            } }
          >
            <span>Üye No:</span>
            <label>{ userId }</label>
            <Icon iconName="svgCopyHeader" className="account-info__detail__id--copy" />
          </div>
        </div>
      </div>

      { this.state.activeDropPanel === 'accountPanel' && (

        <DropPanelDesktop onClose={ this.closeDropPanel } width={ 187 }>
          <div className="account-menu-desktop">
            <div className="account-menu-desktop__links">
              <Link title="Kişisel Bilgilerim" className="account-menu-desktop__links__link" to='/kisisel-bilgilerim' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Kişisel Bilgilerim' });
                this.closeDropPanel();
              } }>
         Kişisel Bilgilerim
              </Link>
              <Link title="Hesabım" className="account-menu-desktop__links__link" to='/hesabim' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Hesabım' });
                this.closeDropPanel();
              } }>
         Hesabım
              </Link>
              <Link title="Kampanyalar" className="account-menu-desktop__links__link" to='/kampanyalar' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Kampanyalar' });
                this.closeDropPanel();
              } }>
         Kampanyalar
              </Link>
              <Link title="Ayarlar" className="account-menu-desktop__links__link" to='/ayarlar' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Ayarlar' });
                this.closeDropPanel();
              } }>
         Ayarlar
              </Link>
              { EnvironmentManager.getMessageText({ key: 'world_cup_history_visible' }) === 'true'
                && <Link title="Dünya Kupası Nostalji" className="account-menu-desktop__links__link" to={ { pathname: '/dunya-kupasi-nostalji', state: { clickPoint: 'Menü' } } } onClick={ () => {
                  this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Dünya Kupası Nostalji' });
                  this.closeDropPanel();
                } }>
                  <span style={ { whiteSpace: 'nowrap' } }>Dünya Kupası Nostalji</span>
                </Link>
              }
              { EnvironmentManager.getMessageText({ key: 'league_center_toogle_on' }) === 'true'
                && <Link title="Lig Merkezi" className="account-menu-desktop__links__link" to='/lig-merkezi' onClick={ () => {
                  this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Lig Merkezi' });
                  this.closeDropPanel();
                } }>
                  <span>Lig Merkezi</span>
                </Link>
              }
              { EnvironmentManager.getMessageText({ key: 'bilyoner_blog_footer_visible' }) === 'true'
                && <a title="Bilyoner Blog" className="account-menu-desktop__links__link" href={ EnvironmentManager.getMessageText({ key: 'bilyoner_blog_footer_link' }) } target="_blank" rel="nofollow noreferrer" onClick={ () => {
                  this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Bilyoner Blog' });
                  this.closeDropPanel();
                } }>
                  <span>Bilyoner Blog</span>
                </a>
              }
              <Link title="Bilyonpuan" className="account-menu-desktop__links__link" to='/yilin-enleri' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Bilyoner\'in En\'leri' });
                this.closeDropPanel();
              } }>
                { 'Bilyoner\'in En\'leri' }
              </Link>
              {
                EnvironmentManager.getMessageText({ key: 'reference_page_visible' }) === 'true'
              && <Link title={ referencePageTitle } className="account-menu-desktop__links__link" to='/arkadasini-getir' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': referencePageTitle });
                this.closeDropPanel();
              } }>
                { referencePageTitle }
              </Link>
              }
              <Link title="Duyurular" className="account-menu-desktop__links__link" to='/duyurular' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Duyurular' });
                this.closeDropPanel();
              } }>
         Duyurular
                { unreadAnnouncementsCount > 0 && <Badge className="account-menu-desktop__links__link__badge">{ unreadAnnouncementsCount }</Badge> }
              </Link>
              <Link title={ informationSecurityPolicyTitle } className="account-menu-desktop__links__link" to='/bilgi-guvenligi-politikasi' onClick={ this.closeDropPanel }>
                { informationSecurityPolicyTitle }
              </Link>
              <Link title="Yardım" className="account-menu-desktop__links__link" to='/yardim' onClick={ () => {
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Yardım' });
                this.closeDropPanel();
              } }>
         Yardım
              </Link>
            </div>

            <Link
              title="Çıkış Yap"
              className="account-menu-desktop__logout"
              to={ '/cikis-yap' }
              onClick={ e => {
                e.stopPropagation();
                this.props.mixpanel.track('Click Hamburger Menu Item', { 'Menu Item Name': 'Çıkış Yap' });
              } }
            >
              <Icon iconName="svgLogout" className="account-menu-desktop__logout__icon" />
       Çıkış Yap
            </Link>
          </div>
        </DropPanelDesktop>
      ) }
    </div>
    <div className="vertical-divider" />

    <div className="account-balance">
      <Icon
        iconName="svgSync"
        disabled={ this.state.getBalanceDisable }
        className={ iconClasses }
        onClick={ () => {
          this.props.updateUserBalance();
          this.setState({
            getBalanceDisable: true
          });
          setTimeout(() => {
            this.setState({
              getBalanceDisable: false
            });
          }, 1000);
        } }
      />
      <div className="account-balance__price" onClick={ () => History.push('/hesabim/hesap-hareketlerim') }>{   privacy?.isEyeOpen ? `${privacy?.balance} TL` : privacy?.balance }</div>
      <i
        className="bly bly-arrow-down bly-white bly-size16 account-balance__arrow-icon"
        onClick={ () => {
          this.props.mixpanel.track('Click Hamburger Menu', {
            'Click Point': 'Arrow Icon'
          });
          this.openDropPanel('accountPanel');
        } }
      />
    </div>
  </div>
        </>
    );
  };

  updateIsDesktop = () => {
    this.setState({
      isDesktop: window.innerWidth > 768
    });
  };

  getHeaderTargetPath = item => {
    const bulletinTabs = this.props.sportsBookTabs?.bulletinTabs || [];

    const liveTab = bulletinTabs.find(tab => tab.id === BULLETIN_TYPES.LIVE);
    const hasLiveEvent = Boolean(liveTab?.count);

    if (item.path === '/iddaa') {
      return hasLiveEvent ? '/canli-iddaa' : '/iddaa';
    }

    return item.path;
  };

  render () {
    const { type,
      auth,
      userAgent: { os, device },
      helmet,
      tribun,
      getUserTribunToken,
      openModal,
      unreadAnnouncementsCount,
      subHeader,
      showSubHeader = true
    } = this.props;
    const { popoverText, activeDropPanel, isDesktop, isAtTop } = this.state;

    const dwSwitch = EnvironmentManager.getMessageText({
      key: 'mw_dw_transition_switch'
    }) === 'true';

    const alternativeText = EnvironmentManager.getMessageText({
      key: 'mw_main_page_text'
    });

    const mwDeepLink = EnvironmentManager.getMessageText({
      key: 'mw_main_page_deeplink'
    });

    const showResponsibleGambling = EnvironmentManager.getMessageText({
      key: 'mainpage_responsible_gambling_icon_visible'
    }) === 'true';

    const headerSimple = (
      <div className="header header--center">
        <Link to="/" className="header__logo" title="Bilyoner" />
      </div>
    );

    const headerLoginOnly = (
      <div className="header-login-only">
        <div className="header-login-only__container">
          <Link to="/" className="header-login-only__logo" title="Bilyoner" />
          <NoSSR>
            { auth.isAuthenticated ? null : (
              <div className="header-login-only__actions">
                <a
                  title="Giriş Yap"
                  rel="nofollow"
                  className={ classnames({
                    'header-login-only__login': true,
                    'header-login-only__login--active': activeDropPanel === 'loginPanel'
                  }) }
                  onClick={ () => isDesktop ? this.openDropPanel('loginPanel') : History.push('/giris-yap') }
                >
                  Giriş Yap
                </a>
                { activeDropPanel === 'loginPanel' && (
                  <DropPanelDesktop onClose={ this.closeDropPanel }>
                    <LoginForm />
                  </DropPanelDesktop>
                ) }
              </div>
            ) }
          </NoSSR>
        </div>
      </div>
    );

    const pathname = History.location?.pathname;
    const isHomePage = pathname === '/' || pathname == null;
    const isMobileHome = this.props.userAgent?.device?.type === 'mobile' && isHomePage;
    const isTjkPages = History?.location?.pathname?.startsWith('/tjk');
    const showTvButton = (History?.location?.pathname?.includes(TJK_URL_SUFFIX.program.fullPage) || History?.location?.pathname?.includes(TJK_URL_SUFFIX.fixedOdd.fullPage)) && isMobile && auth.isAuthenticated;
    const isDesktopDevice = device?.type === 'desktop';
    const showHeaderSkeleton = !isHomePage && !(subHeader?.data?.length > 0);
    const headerSkeletonProps = {
      auth,
      userAgent: this.props.userAgent,
      openDropPanel: this.openDropPanel,
      toggleMenu: this.toggleMenu,
      activeDropPanel: this.state.activeDropPanel,
      closeDropPanel: this.closeDropPanel,
    };

    const headerTop = (<NoSSR>
      <div
        className={ classnames({
          'header-desktop': true,
          'header-desktop--no-shadow': this.props.userAgent.device?.type === 'desktop',
          'header-desktop__visible': !(this.props.userAgent.device?.type !== 'desktop' && History.location?.pathname &&  History.location?.pathname.includes('/sans-oyunlari')),
          'header-desktop__blur': this.props.showVaixSearch,
          // Anasayfa banner varyantı (yalnızca anasayfada)
          'header-desktop--home-banner': isMobileHome,
          'header-desktop--bg-transparent': isMobileHome && isAtTop,
          'header-desktop--variant-solid': isMobileHome && !isAtTop,
          'header-desktop__ag': isTjkPages && isMobile,
        }) }>
        <div className={ classnames({
          wrapper: true,
          'wrapper--home-banner': isMobileHome,
          'header-desktop__container': true
        }) }>

          { !isDesktop && !isAtTop && isMobileHome
            ? <i className="bly bly-home bly-white bly-size24"/>
            : <Link to="/" className="header-desktop__logo"/>
          }

          {
            showTvButton && <TvButton />
          }

          { !isDesktop && !isAtTop && !this.props.showVaixSearch && this.state.isSearchEnabled && isHomePage && (
            <VaixSearchInput
              className="vaix-search__scroll-header"
              placeholder={ EnvironmentManager.getMessageText({ key: 'main_page_search_text' }) }
              inputType="text"
              iconName="svgSearchDropPanelV2"
              onClick={ () => History.push('/anasayfa-arama') }
            />
          ) }

          { this.props.userAgent.device?.type === 'desktop' && !this.props.showVaixSearch && this.state.isSearchEnabled && isHomePage && (
            <VaixSearchInput
              placeholder={ EnvironmentManager.getMessageText({ key: 'main_page_search_text' }) }
              inputType="text"
              onClick={ () => History.push('/anasayfa-arama') }
            />
          ) }

          <div className="header-desktop__account">
            <div className="header-desktop__help-group">
              <div className="header-lang-help__buttons-container">
                <Link to="/" title="Yardım" className={ classnames({
                  'header-lang-help__buttons btn-help': true,
                  'header-lang-help__buttons--underline': History.location?.pathname?.includes('/yardim')
                }) } onClick={ () => this.redirectHelpFromHeader('/yardim') }>
                  <Icon iconName="svgHelpWhite" className="header-lang-help__buttons lang-help-icons"/>
                  <span>Yardım</span>
                </Link>
              </div>
              { isHomePage && showResponsibleGambling && (
                <div className="header-responsible-gambling">
                  <span className="header-responsible-gambling__divider"/>
                  <Link to="/bilyoner/sorumlu-bahis" title="Sorumlu Oyun" className="header-responsible-gambling__link" onClick={ () => {
                    this.props.mixpanel.track('Click Main Page Responsible Gambling');
                  } }>
                    <Icon iconName={ isDesktopDevice ? 'svgResponsibleGambling' : 'svgResponsibleGamblingMobile' } className="header-responsible-gambling__icon"/>
                    <span className="header-responsible-gambling__text">Sorumlu Oyun</span>
                  </Link>
                </div>
              ) }
            </div>
            <UserProfile
              auth={ auth }
              loginUser={ loginUser }
              logoutUser={ logoutUser }
              getUserTribunToken={ getUserTribunToken }
              platform={ os?.name }
              device={ device }
              helmet={ helmet }
              tribun={ tribun }
              openModal={ openModal }
              unreadAnnouncementsCount={ unreadAnnouncementsCount }
              isMenuOpen={ this.state.isMenuOpen }
              countOpen={ this.state.countOpen }
            />

            { auth.isAuthenticated === null ? null : auth.isAuthenticated ? (
              this.renderMegaHeaderAccountInfo()
            ) : (
              <div className="header-login__buttons-container">
                { isDesktopDevice && (
                  <ThemeSegmentedControl
                    compact
                    className="header-login__theme-toggle"
                    clickPoint={ THEME_CLICK_POINTS.HEADER }
                  />
                ) }
                <RegisterLoginButtons openLoginPanel={ () => this.openDropPanel('loginPanel') }
                  isDesktop={ isDesktopDevice }
                  toggleMenu={ this.toggleMenu }/>
                { this.state.activeDropPanel === 'loginPanel' && (
                  <DropPanelDesktop onClose={ this.closeDropPanel }>
                    <LoginForm/>
                  </DropPanelDesktop>
                ) }
              </div>
            ) }
          </div>

        </div>

        { this.props.userAgent.device?.type !== 'desktop' && !this.props.showVaixSearch && this.state.isSearchEnabled && isHomePage && isAtTop && (
          <div className="header-desktop__search header-desktop__search--home-banner">
            <VaixSearchInput
              placeholder= { EnvironmentManager.getMessageText({ key: 'main_page_search_text' }) }
              inputType="text"
              iconName="svgSearchDropPanelV2"
              className="vaix-search__header-v2"
              onClick={ () => History.push('/anasayfa-arama') }
            />
          </div>
        ) }

        <div className={ classnames({
          'account-menu__popover': true,
          'account-menu__popover--show': popoverText
        }) }>
          <div className="account-menu__popover-text">{ popoverText }</div>
        </div>
      </div>
    </NoSSR>);

    const headerBottom = (
      <div className={ classnames({
        'header-buttons': true,
        'header-buttons__blur': this.props.showVaixSearch
      }) }>
        <NoSSR>
          <div className={
            classnames({
              'header-buttons-wrapper-desktop': this.props.userAgent.device?.type === 'desktop'
            })
          }>
            <div className= { classnames({
              'buttons-container': true,
              'buttons-container-desktop': this.props.userAgent.device?.type === 'desktop'
            }) }>
              { HEADER_LINKS
                .filter(item => !item.visibleKey || EnvironmentManager.getMessageText({ key: item.visibleKey }) === 'true')
                .map((item, index) => (
                  <a
                    title={ item.content }
                    href={ item.path }
                    className={ classnames({
                      'header-link': true,
                      'header-link-desktop': this.props.userAgent.device?.type === 'desktop',
                      'link-active': HEADER_LINKS[getActiveIndexByPath(item)] === item,
                      'link-active-desktop': (HEADER_LINKS[getActiveIndexByPath(item)] === item && this.props.userAgent.device?.type === 'desktop')
                    }) }
                    onClick={ e => {
                      e.preventDefault();

                      const targetPath = this.getHeaderTargetPath(item);

                      const targetUrl = `${window.location.origin}${targetPath}`;
                      this.props.mixpanel.track('Click Website Header', {
                        'Tab Name': item.content,
                        'Tab Link': targetPath,
                        URL: targetUrl,
                        $current_url: targetUrl,
                      });

                      if (item.path === '/sans-oyunlari/esya-piyangosu') {
                        this.redirectRaffleUrl();
                      } else if (History.location?.pathname !== targetPath) {
                        History.push(targetPath);
                      }
                      item.content === 'Canlı Maç İzle' && this.props.mixpanel.track('Click Main Page Live Streams', { 'Area Type:': 'Anasayfa' });
                      item.content === 'Çoklu Maç Takibi' && this.props.mixpanel.track('Click Main Page Multiple LMT', { 'Click Source': 'Header' });
                      item.content === 'Tribün' && this.props.mixpanel.track('Click Main Page Tribun', { 'Area Type': 'Header' });
                      item.content === 'Kampanyalar' && this.props.mixpanel.track('Click Main Page Campaigns', { 'Area Type:': 'Header' });
                      item.content === 'Lig Merkezi' && this.props.mixpanel.track('View League Center Page', { 'Click Point': 'Header' });
                    } }
                    key={ index }
                  >
                    <div className='header-link__content'>
                      <Icon iconName={ item.iconName }/>
                      <div className='header-button-text'>{ item.content }</div>
                    </div>

                    { item.badgeNew && <Badge isNew="true" className={ 'new-badge' }>Yeni</Badge> }
                  </a>
                )) }
            </div>
          </div>
        </NoSSR>
      </div>
    );

    const headerSub = (
      <div className="sub-header-wrapper__container">
        { subHeader?.data?.length > 0 && showSubHeader && History.location?.pathname === '/'
          && <div className={ classnames({
            'sub-header-wrapper': true,
            'sub-header-wrapper__visible': History.location?.pathname === '/',
          }) }>
            <SportTypeMenu { ...subHeader }/>
          </div> }

        { History.location?.pathname?.includes('/tjk') && isDesktop && <TjkSubMenu /> }

        { dwSwitch && this.props.userAgent.device?.type === 'desktop' && History.location?.pathname === '/'
          && <div className='site-navigator'>
            <a href={ mwDeepLink } className='dw-link text-decoration-none'>{ alternativeText }</a>
          </div> }
      </div>

    );

    let headerTemplate;

    switch (type) {
      case 'mobile-none':
        headerTemplate = null;
        break;

      case 'simple':
        headerTemplate = headerSimple;
        break;

      case 'login-only':
        headerTemplate = headerLoginOnly;
        break;

      case 'full':
        headerTemplate = (
          <>
            { showHeaderSkeleton
              ? <HeaderSkeleton { ...headerSkeletonProps } />
              :              <>
            { isDesktop ? (
              <div className={ classnames({
                'header-bg-wrapper': true,
                'header-bg-wrapper--drop-panel-open': !!activeDropPanel,
              }) }>
                { headerTop }
                { headerBottom }
              </div>
            ) : (
              <>
                { headerTop }
                { headerBottom }
              </>
            ) }
            { headerSub }
          </>
            }</>
        );
        break;

      default:
        break;
    }

    return (
      <>
        { headerTemplate }
      </>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  userAgent: state.userAgent,
  tribun: state.tribun,
  unreadAnnouncementsCount: state.announcement.seenAnnouncements.unseenNewsCount,
  subHeader: state.home.subHeader,
  allCategories: state.allCategories,
  modalData: state.modalData,
  sportsBookTabs: state.sportsBook.sportsBookTabs,
});

export default connect(
  mapStateToProps,
  { loginUser, logoutUser, getUserTribunToken, openModal, getAllCategoriesList, updateUserBalance, getDisplayCommunicationSettings, toggleSideMenu, clearPendingMembership, resetLoginFailure }
)(withMixpanel(withPrivacyEye(HeaderMobile)));
